(() => {
    'use strict';

    const document = window.document,
        $ = jQuery;

    $(document).ready(() => {
        // ------------------------------
        // Countdown Timer on Checkout Page
        // ------------------------------
        function initializeCountdownWithAutoClick() {
            const targetDiv = document.querySelector(
                '.iconic-wsb-modal__product.iconic-wsb-modal-product-offer'
            );
            if (!targetDiv) {
                return;
            }

            const countdownDiv = document.createElement('div');
            countdownDiv.setAttribute('id', 'lanumaCheckoutCountdownTimer');
            countdownDiv.innerHTML =
                '<span id="lanumaCheckoutTimer">03:00</span>';
            targetDiv.parentNode.insertBefore(countdownDiv, targetDiv);

            let time = 8 * 60;
            const timerElement = document.getElementById('lanumaCheckoutTimer');

            const countdown = setInterval(() => {
                const minutes = Math.floor(time / 60);
                const seconds = time % 60;
                timerElement.textContent = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

                if (--time < 0) {
                    clearInterval(countdown);
                    countdownDiv.parentNode.removeChild(countdownDiv);
                    const skipButton = document.querySelector(
                        '.iconic-wsb-modal-product-offer__btn-skip'
                    );
                    if (skipButton) {
                        skipButton.click();
                    }
                }
            }, 1000);
        }

        // ------------------------------
        // Initialize Magnific Popup for Lightbox Links
        // ------------------------------
        function initMagnificPopupForLightbox() {
            $('.lightbox-link').magnificPopup({
                type: 'image',
                gallery: {enabled: true}
            });
        }

        // ------------------------------
        // Initialize Front Page Slick Slider
        // ------------------------------
        function initFrontPageSlider() {
            $('.front-page--slider-wrapper').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                speed: 500,
                infinite: true,
                arrows: true,
                dots: true
            });
        }

        // ------------------------------
        // Lazy Load Elements using IntersectionObserver
        // ------------------------------
        function initLazyLoad() {
            const lazyLoadDivs = document.querySelectorAll('.lanuma-lazy-load');
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            });
            lazyLoadDivs.forEach((div) => observer.observe(div));
        }

        // ------------------------------
        // Initialize Size-Fit Popup (Magnific)
        // ------------------------------
        function initSizeFitPopup() {
            $('.lanuma-size-fit-popup-btn').magnificPopup({
                type: 'inline',
                preloader: false,
                closeOnBgClick: true
            });
        }

        // ------------------------------
        // Accordion Functionality on Single Product Page
        // ------------------------------
        function initAccordion() {
            const items = document.querySelectorAll(
                '.single-product--accordion-header'
            );
            items.forEach((item) => {
                item.addEventListener('click', function () {
                    const isExpanded =
                        this.getAttribute('aria-expanded') === 'true';
                    items.forEach((i) =>
                        i.setAttribute('aria-expanded', 'false')
                    );
                    if (!isExpanded) {
                        this.setAttribute('aria-expanded', 'true');
                    }
                });
            });
        }

        // ------------------------------
        // Sticky Scroll for Specific Section (non-checkout pages)
        // ------------------------------
        function initStickyScroll() {
            if (!document.body.classList.contains('woocommerce-checkout')) {
                let lastScrollTop = 0;
                let isScrollingUp = false;

                window.addEventListener('scroll', () => {
                    const stickySection = document.getElementById(
                        'sticky-section__mobile'
                    );
                    if (stickySection) {
                        const currentScrollTop =
                            window.pageYOffset ||
                            document.documentElement.scrollTop;

                        if (window.innerWidth <= 1024) {
                            stickySection.classList.toggle(
                                'sticky',
                                currentScrollTop > stickySection.offsetTop
                            );
                        } else {
                            isScrollingUp = currentScrollTop < lastScrollTop;

                            if (
                                isScrollingUp &&
                                currentScrollTop > stickySection.offsetTop
                            ) {
                                stickySection.classList.add('sticky');
                            } else {
                                stickySection.classList.remove('sticky');
                            }

                            lastScrollTop =
                                currentScrollTop <= 0 ? 0 : currentScrollTop;
                        }
                    }
                });
            }
        }

        // ------------------------------
        // Restrict Billing Phone Field to Numbers Only
        // ------------------------------
        function restrictBillingPhoneInput() {
            $('#billing_phone').on('keypress', function (e) {
                const charCode = e.which || e.keyCode;
                if (String.fromCharCode(charCode).match(/[^0-9]/)) {
                    e.preventDefault();
                }
            });
        }

        // ------------------------------
        // Initialize Customer Slider (Slick)
        // ------------------------------
        function initCustomerSlider() {
            $('.customer-slider').slick({
                slidesToShow: 3, // Show 3 reviews in one row
                slidesToScroll: 3, // Scroll by 3 reviews per slide
                arrows: true,
                autoplay: true,
                autoplaySpeed: 3500,
                prevArrow:
                    '<button type=\'button\' class=\'slick-prev pull-left lanuma-left-arrow\'><i class=\'fa fa-angle-left\' aria-hidden=\'true\'></i></button>',
                nextArrow:
                    '<button type=\'button\' class=\'slick-next pull-right lanuma-right-arrow\'><i class=\'fa fa-angle-right\' aria-hidden=\'true\'></i></button>',
                responsive: [
                    {
                        breakpoint: 1024, // Adjust for tablets
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768, // Adjust for mobile
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }

        // ------------------------------
        // Scroll to Top on WooCommerce Error After Ajax Complete
        // ------------------------------
        function scrollToTopOnError() {
            $(document).ajaxComplete(() => {
                if ($('.woocommerce-error').length) {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }
            });
        }

        // ------------------------------
        // Initialize Tab Switching on Single Product Page
        // ------------------------------
        function initTabs() {
            if (document.body.classList.contains('single-product')) {
                const tabs = document.querySelectorAll(
                    '.customer-tabs--section-content .tab-content'
                );
                const tabButtons = document.querySelectorAll(
                    '.customer-tabs--section-titles button'
                );

                const changeTab = (tabId) => {
                    tabs.forEach((tab) => tab.classList.remove('active-tab'));
                    const selectedTab = document.getElementById(tabId);
                    if (selectedTab) {
                        selectedTab.classList.add('active-tab');
                    }
                    tabButtons.forEach((button) =>
                        button.classList.remove('active-button')
                    );
                    const clickedButton = document.querySelector(
                        `button[data-tab-id="${tabId}"]`
                    );
                    if (clickedButton) {
                        clickedButton.classList.add('active-button');
                    }
                };

                tabButtons.forEach((button) => {
                    button.addEventListener('click', function () {
                        changeTab(this.getAttribute('data-tab-id'));
                    });
                });

                // Default tab.
                changeTab('tab1');
            }
        }

        // ------------------------------
        // Initialize Opinion Popup
        // ------------------------------
        function initOpinionPopup() {
            $('.lanuma-write-an-opinion-popup').magnificPopup({
                type: 'inline',
                preloader: false,
                closeOnBgClick: true
            });
        }

        // ------------------------------
        // Move Coupon Form on Checkout Page
        // ------------------------------
        function moveCouponFormOnCheckout() {
            if ($('body').hasClass('woocommerce-checkout')) {
                const couponForm = $(
                    '.checkout_coupon.woocommerce-form-coupon'
                );
                const orderReviewHeading = $('#order_review_heading');
                couponForm.insertAfter(orderReviewHeading).addClass('show');
            }
        }

        // ------------------------------
        // Update Gift Card Placeholders Based on Language
        // ------------------------------
        function updateGiftCardPlaceholders() {
            const placeholders = {
                'sl-SI':
                    'Napišite sporočilo osebi, kateri želite podariti kartico (primer: Draga prijateljica, ob tvojem rojstnem dnevu ti podarjam darilno kartico Lanuma. Tvoja Ana)',
                cs: 'Napište vzkaz osobě, které kartu darujete (například: Moje milá, tady máš ode mě k narozeninám dárkovou kartu Lanuma. S láskou, Anna)',
                'sk-SK':
                    'Napíšte odkaz osobe, ktorej chcete kartu darovať (napr: Milá priateľka, k narodeninám ti darujem darčekovú kartu Lanuma. S láskou, Anna)',
                hu: 'Írjon üzenetet annak a személynek, akinek a kártyát szeretné adni (pl: Lanuma ajándékkártya a születésnapodra. Szeretettel: Anna)',
                'pl-PL':
                    'Napisz wiadomość do osoby, której chcesz podarować kartę (przykład: Droga przyjaciółko, na Twoje urodziny chcę podarować Ci kartę podarunkową Lanuma. Ściskam, Anna)',
                hr: 'Napišite poruku za osobu kojoj želite poslati darovnu karticu (na primjer: Draga prijateljice, za rođendan ti darujem Lanuma darovnu karticu. Voli te Ana)',
                'bg-BG':
                    'Напишете съобщение до лицето, на което искате да подарите картата (например: Скъпи приятелю, подарявам ти карта за подарък Lanuma за рождения ти ден. С обич, Анна)',
                'ro-RO':
                    'Scrie un mesaj pentru persoana căreia dorești să îi oferi cardul (exemplu: Dragă prietenă, îți dăruiesc un card cadou Lanuma de ziua ta. Cu drag, Ana)'
            };
            const lang = $('html').attr('lang');
            if (lang && placeholders[lang]) {
                $('#ywgc-edit-message').attr('placeholder', placeholders[lang]);
            }
        }

        // ------------------------------
        // Initialize Expedico Message Insertion on Checkout
        // ------------------------------
        function initExpedicoMessage() {
            function insertExpedicoMessage() {
                const lang = $('html').attr('lang');
                let messageText;
                switch (lang) {
                    case 'cs':
                        messageText =
                            'Je třeba potvrdit místo vyzvednutí. Potvrďte jej kliknutím na tlačítko Vyzvednout zde.';
                        break;
                    case 'sk-SK':
                        messageText =
                            'Je potrebné potvrdiť miesto vyzdvihnutia. Potvrďte ho kliknutím na tlačítko Vyzdvihnite tu.';
                        break;
                    case 'pl-PL':
                        messageText =
                            'Wymagane jest potwierdzenie punktu odbioru. Potwierdź, klikając na przycisk Odbierz tutaj.';
                        break;
                    default:
                        messageText =
                            'Please confirm the pickup point by clicking the button.';
                }
                const $widget = $(
                    `html[lang='${lang}'] .woocommerce-checkout .lanuma-expedico #expedico_widget`
                );
                if (
                    $widget.length &&
                    !$widget.next().hasClass('expedico-message')
                ) {
                    const $messageEl = $('<div>')
                        .addClass('expedico-message')
                        .text(messageText)
                        .css({
                            display: 'block',
                            marginBottom: '10px',
                            fontSize: 'var(--text-sm)',
                            fontStyle: 'italic',
                            lineHeight: 'var(--leading-6)',
                            color: 'var(--color-secondary)'
                        });
                    $widget.after($messageEl);
                }
            }

            $('#expedico_delivery').on('click', insertExpedicoMessage);
            $('#home_delivery').on('click', () => {
                $('.expedico-message').remove();
            });
        }

        //
        function addConditionalBumpsClass() {
            const $container = $('.single-product-page--single-add-to-cart');
            if ($container.find('.iconic-wsb-product-bumps').length) {
                $container.addClass('lanuma-has-bundle');
            }
        }

        addConditionalBumpsClass();

        // ------------------------------
        // Auto-select Next Available Variation
        // ------------------------------
        function initAutoVariationSelection() {
            if (document.body.classList.contains('single-product')) {
                // Handle variation radio button changes
                $(document).on(
                    'change',
                    '.variation-radios input[type="radio"]',
                    function () {
                        const $form = $(this).closest('.variations_form');
                        if ($form.length) {
                            // Trigger WooCommerce variation update
                            $form.trigger('check_variations');
                        }
                    }
                );

                // Listen for WooCommerce variation events
                $('.variations_form')
                    // eslint-disable-next-line no-unused-vars
                    .on('found_variation', function (event, variation) {
                        // Variation found and available - no action needed
                    })
                    .on('hide_variation', function () {
                        // Current selection doesn't have a valid variation
                        // Auto-select next available variation
                        autoSelectNextAvailableVariation();
                    });

                function autoSelectNextAvailableVariation() {
                    const $variationRadios = $('.variation-radios');

                    $variationRadios.each(function () {
                        const $container = $(this);
                        const $currentSelected = $container.find(
                            'input[type="radio"]:checked'
                        );
                        const $availableOptions = $container.find(
                            'input[type="radio"]:not(:disabled)'
                        );

                        // If current selection is disabled, select the first available option
                        if (
                            $currentSelected.length &&
                            $currentSelected.is(':disabled')
                        ) {
                            const $firstAvailable = $availableOptions.first();
                            if ($firstAvailable.length) {
                                $firstAvailable
                                    .prop('checked', true)
                                    .trigger('change');
                            }
                        } else if (
                            !$currentSelected.length &&
                            $availableOptions.length
                        ) {
                            // If nothing is selected, select the first available option
                            const $firstAvailable = $availableOptions.first();
                            if ($firstAvailable.length) {
                                $firstAvailable
                                    .prop('checked', true)
                                    .trigger('change');
                            }
                        }
                    });
                }

                // Auto-select on page load if no variation is selected
                $(window).on('load', function () {
                    setTimeout(function () {
                        autoSelectNextAvailableVariation();
                    }, 100);
                });
            }
        }

        // ------------------------------
        // Coupon Notice Date Visibility
        // ------------------------------
        function initCouponNoticeVisibility() {
            const couponNotice = document.querySelector(
                '.lanuma--single-product--coupon-notice'
            );
            if (!couponNotice) {
                return;
            }

            const startDate = couponNotice.getAttribute('data-start-date');
            const endDate = couponNotice.getAttribute('data-end-date');

            // If no dates are set, hide the notice
            if (!startDate && !endDate) {
                return;
            }

            const currentDate = new Date();
            const currentDateString = formatDate(currentDate);

            let shouldShow = true;

            // Check start date
            if (startDate) {
                const startDateObj = parseDate(startDate);
                if (currentDate < startDateObj) {
                    shouldShow = false;
                }
            }

            // Check end date
            if (endDate) {
                const endDateObj = parseDate(endDate);
                if (currentDate > endDateObj) {
                    shouldShow = false;
                }
            }

            if (shouldShow) {
                couponNotice.style.display = 'block';
            }
        }

        // Helper function to parse date in d/m/Y format
        function parseDate(dateString) {
            if (!dateString) return null;
            const parts = dateString.split('/');
            if (parts.length !== 3) return null;
            // Parts: [day, month, year] - convert to Date object
            return new Date(parts[2], parts[1] - 1, parts[0]);
        }

        // Helper function to format date as d/m/Y
        function formatDate(date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }

        // ------------------------------
        // Product Hover Image Touch Handler for Mobile
        // ------------------------------
        function initProductHoverTouch() {
            // Only initialize on touch devices
            if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
                const productItems =
                    document.querySelectorAll('.lanuma-loop-item');

                productItems.forEach((item) => {
                    // Show hover image when touch starts
                    item.addEventListener(
                        'touchstart',
                        function (e) {
                            // Add the class to show hover image
                            this.classList.add('touch-active');
                        },
                        {passive: true}
                    );

                    // Hide hover image when touch ends
                    item.addEventListener(
                        'touchend',
                        function (e) {
                            // Remove the class after a brief delay to show the effect
                            setTimeout(() => {
                                this.classList.remove('touch-active');
                            }, 100);
                        },
                        {passive: true}
                    );

                    // Clean up if touch is cancelled (e.g., scrolling)
                    item.addEventListener(
                        'touchcancel',
                        function (e) {
                            this.classList.remove('touch-active');
                        },
                        {passive: true}
                    );
                });
            }
        }

        // ------------------------------
        // Initialize All Functionalities
        // ------------------------------
        initializeCountdownWithAutoClick();
        initMagnificPopupForLightbox();
        initFrontPageSlider();
        initLazyLoad();
        initSizeFitPopup();
        initAccordion();
        initStickyScroll();
        restrictBillingPhoneInput();
        initCustomerSlider();
        scrollToTopOnError();
        initTabs();
        initOpinionPopup();
        initCouponNoticeVisibility();
        moveCouponFormOnCheckout();
        updateGiftCardPlaceholders();
        initExpedicoMessage();
        initAutoVariationSelection();
        // initProductHoverTouch();
    });

    // Mobile Navigation Toggle with Proper Overlay
    document.addEventListener('DOMContentLoaded', function () {
        const mobileToggle = document.querySelector('.mobile-menu-toggle');
        const navigation = document.querySelector('.primary-navigation');
        const menuItems = document.querySelectorAll(
            '.menu-item-has-children > a'
        );

        // Create overlay element
        const overlay = document.createElement('div');
        overlay.className = 'mobile-menu-overlay';
        overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999;
        opacity: 0;
        visibility: hidden;
        transition: opacity var(--transition-time) ease, visibility var(--transition-time) ease;
    `;
        document.body.appendChild(overlay);

        // Function to disable body scroll
        function disableBodyScroll() {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            document.body.setAttribute('data-scroll-position', scrollY);
        }

        // Function to enable body scroll
        function enableBodyScroll() {
            const scrollY = document.body.getAttribute('data-scroll-position');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY, 10));
                document.body.removeAttribute('data-scroll-position');
            }
        }

        // Function to close mobile menu
        function closeMobileMenu() {
            if (navigation && navigation.classList.contains('active')) {
                navigation.classList.remove('active');
                mobileToggle.classList.remove('active');
                mobileToggle.setAttribute('aria-expanded', 'false');

                // Hide overlay with a slight delay to ensure smooth transition
                overlay.style.opacity = '0';
                overlay.style.visibility = 'hidden';

                // Reset any lingering background styles after transition completes
                setTimeout(() => {
                    if (!navigation.classList.contains('active')) {
                        overlay.style.display = 'none';
                    }
                }, 300); // Match your CSS transition duration

                enableBodyScroll();
            }
        }

        // Function to open mobile menu
        function openMobileMenu() {
            navigation.classList.add('active');
            mobileToggle.classList.add('active');
            mobileToggle.setAttribute('aria-expanded', 'true');

            // Show overlay
            overlay.style.display = 'block';
            // Force reflow before changing opacity for smooth transition
            overlay.offsetHeight;
            overlay.style.opacity = '1';
            overlay.style.visibility = 'visible';

            disableBodyScroll();
        }

        // Mobile menu toggle
        if (mobileToggle && navigation) {
            mobileToggle.addEventListener('click', function () {
                const isActive = navigation.classList.contains('active');

                if (isActive) {
                    closeMobileMenu();
                } else {
                    openMobileMenu();
                }
            });
        }

        // Close menu when clicking on overlay
        overlay.addEventListener('click', function () {
            closeMobileMenu();
        });

        // Handle dropdown clicks on mobile
        menuItems.forEach(function (item) {
            item.addEventListener('click', function (e) {
                if (window.innerWidth <= 1024) {
                    e.preventDefault();
                    const parentLi = this.parentElement;
                    const isActive = parentLi.classList.contains('active');

                    // Close all other dropdowns
                    document
                        .querySelectorAll('.menu-item-has-children.active')
                        .forEach(function (activeItem) {
                            if (activeItem !== parentLi) {
                                activeItem.classList.remove('active');
                            }
                        });

                    // Toggle current dropdown
                    if (isActive) {
                        parentLi.classList.remove('active');
                    } else {
                        parentLi.classList.add('active');
                    }
                }
            });
        });

        // Close mobile menu when clicking outside (but not on overlay, that's handled separately)
        document.addEventListener('click', function (e) {
            if (navigation && navigation.classList.contains('active')) {
                if (
                    !navigation.contains(e.target) &&
                    !mobileToggle.contains(e.target) &&
                    !overlay.contains(e.target)
                ) {
                    closeMobileMenu();
                }
            }
        });

        // Close mobile menu on escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                closeMobileMenu();
            }
        });

        // Handle window resize
        window.addEventListener('resize', function () {
            if (window.innerWidth > 1024) {
                closeMobileMenu();

                // Remove active class from mobile dropdowns
                document
                    .querySelectorAll('.menu-item-has-children.active')
                    .forEach(function (item) {
                        item.classList.remove('active');
                    });
            }
        });
    });
})(this);
